import axios from "axios";
import { message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_organizations = async (token) => {
	try {
		const res = await axios.post(`${apiUrl}/get_organizations`, { token });

		if (res.status === 200) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const edit_organization = async (token, edit_value, data) => {
	try {

		const body = { token, edit_value, data };

		const res = await axios.post(`${apiUrl}/edit_organizations`, body);

		if (res.status === 200) return res.data;
		message.error(res.data);
	} catch (err) {
		console.log(err);
		message.error(err.response.data);
	}
};
